__turbopack_context__.v({
  "energy-type": "qNS37q_energy-type",
  "energy-type__field": "qNS37q_energy-type__field",
  "energy-type__field-inner": "qNS37q_energy-type__field-inner",
  "errors": "qNS37q_errors",
  "errors__icon": "qNS37q_errors__icon",
  "product-lookup": "qNS37q_product-lookup",
  "product-lookup-wrapper": "qNS37q_product-lookup-wrapper",
  "product-lookup__submit": "qNS37q_product-lookup__submit",
  "promo": "qNS37q_promo",
  "promo__checkbox": "qNS37q_promo__checkbox",
  "promo__clear": "qNS37q_promo__clear",
  "promo__field": "qNS37q_promo__field",
  "promo__icon": "qNS37q_promo__icon",
  "promo__input-wrapper": "qNS37q_promo__input-wrapper",
});
